import styled from 'styled-components';

const TabActions = styled.div`
  margin-top: 50px;
  text-align: right;
`;

export { TabActions };
